export const SET_PRODUCT_CART = 'SET_PRODUCT_CART';

export const setProductCart = (products) => {
  return {
    type: SET_PRODUCT_CART,
    payload: products,
  };
};
